import nest from 'recompose/nest'

import FinancesPage from './FinancesPage'
import MyFinances from './SectionPages/MyFinances'
import FundPage from './SectionPages/FundPage'
import { FinancesPageRoot } from './FinancesPageRoot'

export const MyFinancesPage = nest(FinancesPageRoot, nest(FinancesPage, MyFinances))
export const FinancesFundPage = nest(FinancesPageRoot, nest(FinancesPage, FundPage))
